import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { ICommercialIncomeProps } from './types';
import { getIncomeText } from '../../utils/getIncomeText';

export const CommercialIncome: React.FC<ICommercialIncomeProps> = props => {
  const { income, currency, incomePeriod } = props;

  return (
    <UIText2 color="gray60_100" data-testid="CommercialIncome">
      {getIncomeText(income, currency, incomePeriod)}
    </UIText2>
  );
};

CommercialIncome.displayName = 'CommercialIncome';
